import { BettingTypeSelectorsStore as GPBettingTypeSelectorStore } from "@gp/offer";

export class BettingTypeSelectorsStore extends GPBettingTypeSelectorStore {
	constructor() {
		super(1);
	}

	getAllSelectedKeys() {
		const result = new Set();

		for (const sportConfig of this.sportSelections.values()) {
			for (const selector of Object.values(sportConfig)) {
				if (selector) {
					selector.bettingTypes.forEach((bt) => result.add(bt));
				}
			}
		}

		return Array.from(result);
	}
}
